<script>
/**
 * Descripción: Pantalla Clientes Filtro
 *
 * @displayName CustomerFilterViewComponent
 */

import { mapActions } from 'vuex';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';
import httpService from '@/services/httpService.js';

const BaseServerDataTable = () =>
  import('@/components/core/grids/BaseServerDataTable.vue');

export default {
  name: 'CustomerFilterViewComponent',

  components: {
    BaseServerDataTable
  },

  computed: {
    /**
     * Configuracion BaseServerDataTable
     */
    setting() {
      return {
        controller: 'Customer',
        columns: [
          {
            text: 'Nombre',
            align: 'start',
            value: 'customerName',
            show: true
          },
          {
            text: 'Locación',
            align: 'start',
            value: 'locationName',
            show: true
          },
          {
            text: 'Activation Date',
            align: 'start',
            value: 'activationDate',
            type: 'hidden',
            show: true
          },
          {
            text: 'Inactivation Date',
            align: 'start',
            value: 'inactivationDate',
            type: 'hidden',
            show: false
          },
          {
            text: 'Activo',
            align: 'start',
            value: 'activo',
            type: 'hidden',
            show: true
          }
        ],
        key: 'customerId'
      };
    }
  },

  created() {
    /**
     * Configuracion Encabezado
     */
    this.addNavbar(['Clientes']);
  },

  methods: {
    /**
     * Configuración NavBar
     */
    ...mapActions('navbar', ['addNavbar']),

    /**
     * Crear Nuevo Usuario
     */
    $_new() {
      // object
      this.$router.push({ name: 'CustomerEditorViewComponent' });
    },

    /**
     * Editar Pantalla Editor
     */
    $_edit(params) {
      // object
      this.$router.push({
        name: 'CustomerEditorViewComponent',
        params: { Id: params.selected[this.setting.key] }
      });
    },

    /**
     * Eliminar Objecto
     */
    $_delete(params) {
      let object = BaseArrayHelper.SetObject({}, params[0]);
      httpService.post('Customer/Delete', [object]).then(response => {
        if (response != undefined) {
          //Logica JS luego de la acción exitosa!!!
          this.$refs.customerFilter.$_ParamsToAPI();
        }
      });
    }
  }
};
</script>

<template>
  <div>
    <!-- @BaseServerDataTable -->
    <BaseServerDataTable
      ref="customerFilter"
      :setting="setting"
      :fnNew="$_new"
      :fnEdit="$_edit"
      :fnDelete="$_delete"
    />
  </div>
</template>
